import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import KharchoJeetoEntryForm from './KharchoJeetoEntryForm'; 
import { logout } from '../../redux/actions/authActions';

const KharchoJeetoHome = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [userName, setUserName] = useState(authState.user.name || '');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showWinners, setShowWinners] = useState(false);
  const [showBills, setShowBills] = useState(false);

  const resetAll = () => {
    setShowForm(false);
    setShowWinners(false);
    setShowBills(false);
  };
  const handleLogout = () => {
    dispatch(logout());
    navigate("/kharchojeeto");
  };

  return (
    <div className="font-sans text-gray-800 bg-black scroll-smooth">

      {/* Header */}
       <header className="sticky top-0 z-50 bg-teal-800 border-b border-teal-800 px-4 py-2 flex items-center justify-between shadow-lg">
        <div className="flex flex-col max-w-6xl justify-left">
          <div className="text-2xl lg:text-3xl font-bold text-yellow-200">🎉 KharchoJeeto</div>
          <div className="text-sm lg:text-lg text-yellow-200">
            India’s Coolest Daily Spend Contest - Win cash for your chai, ticket or thali!
          </div>
        </div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex flex-wrap justify-center gap-4 font-medium text-white mb-2 sm:mb-0">
          <a href="#prizes" className="hover:text-amber-300 transition">Prizes</a>
          <a href="#qualify" className="hover:text-amber-300 transition">Qualification</a>
          <a href="#process" className="hover:text-amber-300 transition">Process</a>
          <a href="#rejoice" className="hover:text-amber-300 transition">Rejoice</a>
          <a href="#rules" className="hover:text-amber-300 transition">Rules</a>
        </nav>

        {/* Auth Buttons Desktop */}
        <div className="hidden md:flex items-center flex-wrap gap-2">
          {isLoggedIn ? (
            <div className="flex flex-col justify-end items-end">
              <div className="flex flex-row gap-1">
                <button
                  onClick={() => navigate('/kharchojeetodashboard')}
                  className="w-9 h-9 flex items-center justify-center text-lg bg-teal-700 text-white rounded-full hover:bg-amber-500 transition"
                  title="Dashboard"
                >
                  🧭
                </button>
                <button
                  onClick={handleLogout}
                  className="w-9 h-9 flex items-center justify-center text-lg bg-teal-700 text-white rounded-full hover:bg-amber-500 transition"
                  title="Logout"
                >
                  ⏻
                </button>
              </div>
              <div className="text-white text-sm">Welcome, {userName}</div>
            </div>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 sm:px-4 py-2 text-sm border border-amber-400 text-white rounded-full hover:bg-amber-400 hover:text-gray-800 transition"
              >
                Login
              </button>
              <button
                onClick={() => navigate("/signup")}
                className="px-3 sm:px-4 py-2 text-sm bg-teal-500 text-white rounded-full hover:bg-amber-400 transition"
              >
                Register
              </button>
            </>
          )}
        </div>

        {/* Mobile Hamburger */}
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-xl text-white bg-teal-700"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-gradient-to-b from-teal-200 to-amber-200 px-4 py-4 space-y-2 text-center text-gray-800">
          {isLoggedIn && (
            <div className="flex flex-col items-center gap-2">
              <div className="flex flex-row justify-center gap-2">
                <button
                  onClick={() => navigate('/kharchojeetodashboard')}
                  className="w-10 h-10 flex items-center justify-center text-lg bg-teal-700 text-white rounded-full hover:bg-amber-500 transition"
                >
                  🧭
                </button>
                <button
                  onClick={handleLogout}
                  className="w-10 h-10 flex items-center justify-center text-lg bg-teal-700 text-white rounded-full hover:bg-amber-500 transition"
                >
                  ⏻
                </button>
              </div>
              <div>
                <p className="text-teal-600 text-sm">Welcome, {userName}</p>
              </div>
            </div>
          )}
          {["prizes", "qualify", "process", "rejoice", "rules"].map(section => (
            <a
              key={section}
              href={`#${section}`}
              className="block hover:text-teal-600 bg-teal-100 py-2 rounded-md transition"
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </a>
          ))}
          {!isLoggedIn && (
            <div className="flex flex-col sm:flex-row justify-center gap-2 pt-2">
              <button
                onClick={() => navigate("/login")}
                className="px-4 py-2 text-sm border border-amber-400 text-gray-800 rounded-full hover:bg-amber-400 hover:text-white transition"
              >
                Login
              </button>
              <button
                onClick={() => navigate("/signup")}
                className="px-4 py-2 text-sm bg-teal-500 text-white rounded-full hover:bg-amber-400 transition"
              >
                Register
              </button>
            </div>
          )}
        </div>
      )}
      <nav className="flex flex-wrap justify-center gap-2 text-sm lg:text-lg text-white bg-gray-500 py-2 mt-4 mb-2 sm:mb-0">
        <a href="#prizes" className="hover:text-amber-300 transition">🏆 Prizes</a>
        <a href="#qualify" className="hover:text-amber-300 transition">🎯 Qualification</a>
        <a href="#process" className="hover:text-amber-300 transition">⚙️ Process</a>
        <a href="#rejoice" className="hover:text-amber-300 transition">🎉 Rejoice</a>
        <a href="#rules" className="hover:text-amber-300 transition">📜 Rules</a>
      </nav>

      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center flex flex-col items-center justify-center text-white px-4"
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 text-center w-full">
          <h1 className="text-xl sm:text-2xl font-bold mb-4">
            Har din ka bill, har din ka inaam!
          </h1>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 place-items-center w-full">
            <button
              onClick={() => {
                resetAll();
                setShowForm(true);
              }}
              className="w-full px-6 sm:px-8 py-3 text-base sm:text-lg font-semibold bg-teal-600 rounded-lg hover:bg-amber-500 transition-all shadow-md border border-teal-500"
            >
              🧾 Post Your Bill
            </button>
            <button
              onClick={() => {
                resetAll();
                setShowWinners(true);
              }}
              className="w-full px-6 sm:px-8 py-3 text-base sm:text-lg font-semibold bg-emerald-600 rounded-lg hover:bg-amber-500 transition-all shadow-md border border-teal-500"
            >
              🏆 View Previous Day Winners
            </button>
            <button
              onClick={() => {
                resetAll();
                setShowBills(true);
              }}
              className="w-full px-6 sm:px-8 py-3 text-base sm:text-lg font-semibold bg-indigo-600 rounded-lg hover:bg-amber-500 transition-all shadow-md border border-teal-500"
            >
              📂 My Bills
            </button>
          </div>

          <div className="mt-6">
            {showForm && (
              <div className="w-full">
                <KharchoJeetoEntryForm onClose={() => setShowForm(false)} />
              </div>
            )}

            {showWinners && (
                <div className="bg-[#121212] border border-teal-500 rounded-lg p-4 mt-2 shadow-md">
                  <h3 className="text-yellow-400 text-xl font-semibold mb-3 flex items-center justify-center gap-2">
                    🏅 Yesterday’s Winners
                    <span className="text-sm text-gray-400 font-normal">
                      ({new Date(Date.now() - 86400000).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })})
                    </span>
                  </h3>

                  <div className="space-y-3 text-gray-200 text-sm sm:text-base">
                    {/* 🥇 Winner 1 */}
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between bg-[#1c1c1c] px-3 py-2 rounded-lg border-l-4 border-yellow-400">
                      <div className="font-semibold text-yellow-300">
                        🥇 Rina Sharma — ₹480 Voucher
                      </div>
                      <div className="text-gray-400 text-xs sm:text-sm">
                        Referer: <span className="text-pink-400">Kavita Singh</span> · Shopkeeper:{" "}
                        <span className="text-emerald-400">Gupta Sweets</span>
                      </div>
                    </div>

                    {/* 🥈 Winner 2 */}
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between bg-[#1c1c1c] px-3 py-2 rounded-lg border-l-4 border-gray-400">
                      <div className="font-semibold text-gray-300">
                        🥈 Asha Patel — ₹125 Voucher
                      </div>
                      <div className="text-gray-400 text-xs sm:text-sm">
                        Referer: <span className="text-pink-400">Salma Sheikh</span> · Shopkeeper:{" "}
                        <span className="text-emerald-400">Navjot Floor Mill</span>
                      </div>
                    </div>

                    {/* 🥉 Winner 3 */}
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between bg-[#1c1c1c] px-3 py-2 rounded-lg border-l-4 border-amber-400">
                      <div className="font-semibold text-amber-300">
                        🥉 Meena Das — ₹500 Voucher
                      </div>
                      <div className="text-gray-400 text-xs sm:text-sm">
                        Referer: <span className="text-pink-400">Anuradha Rani</span> · Shopkeeper:{" "}
                        <span className="text-emerald-400">George Corner Store</span>
                      </div>
                    </div>
                  </div>
                </div>
            )}

            {showBills && (
              <div className="text-center bg-[#1a1a1a] border border-teal-500 rounded-lg p-4">
                <h3 className="text-yellow-200 text-xl font-semibold mb-2">
                  📜 My Bills
                </h3>
                <p className="text-gray-300 text-sm">
                  You haven’t uploaded any bills yet.  
                  <br />
                  <button
                    onClick={() => {
                      resetAll();
                      setShowForm(true);
                    }}
                    className="mt-2 bg-teal-600 hover:bg-amber-500 text-white px-4 py-2 rounded-lg shadow-md border border-teal-500"
                  >
                    ➕ Upload Now
                  </button>
                </p>
              </div>
            )}
          </div>

          {/* Ads */}
          <div className="mt-4 flex flex-col sm:flex-row gap-4 justify-center w-full flex-wrap">
            <img
              src="/assets/ads/kharchojeeto-ad-full.jpg"
              alt="Full Width Ad"
              className="rounded-lg shadow-md w-full sm:w-[700px] h-auto object-contain"
            />
            <div className="flex flex-col sm:flex-row gap-4 justify-center w-full">
              <img
                src="/assets/ads/kharchojeeto-ad-left.jpg"
                alt="Left Half Ad"
                className="rounded-lg shadow-md w-full sm:w-[300px] h-auto object-contain"
              />
              <img
                src="/assets/ads/kharchojeeto-ad-right.jpg"
                alt="Right Half Ad"
                className="rounded-lg shadow-md w-full sm:w-[300px] h-auto object-contain"
              />
            </div>
          </div>
          <p className="mt-2 text-gray-200 text-center">Advertise with us.</p>
        </div>
      </section>

      {/* Contest Sections */}
      <section id='prizes' className="py-4 px-4 sm:px-10 bg-gray-700 text-white border border-teal-400 text-center">
        <h2 className="text-xl lg:text-2xl font-bold text-yellow-200 mb-2">Turn Your Daily Spends into Daily Wins!</h2>
        <p className="mb-2 text-m lg:text-xl text-white">Win Big. Daily. Effortlessly. So many <strong>Lucky Winners</strong> Every Day!</p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
          <div className="bg-teal-100 p-4 rounded-lg shadow-sm">
            <span className="text-2xl">🥇</span>
            <p className="text-gray-800">1st Prize: ₹1000</p>
          </div>
          <div className="bg-teal-100 p-4 rounded-lg shadow-sm">
            <span className="text-2xl">🥈</span>
            <p className="text-gray-800">2nd Prize (2 winners): ₹500 each</p>
          </div>
          <div className="bg-teal-100 p-4 rounded-lg shadow-sm">
            <span className="text-2xl">🥉</span>
            <p className="text-gray-800">3rd Prize (4 winners): ₹250 each</p>
          </div>
        </div>
        <p className="text-yellow-200 font-medium">Double your prize! Subscribe to Think5Whys + Refer 5 friends 🎉</p>
      </section>

      <section
          id="qualify"
          className="py-6 px-4 sm:px-10 bg-gray-900 border border-teal-400 rounded-lg shadow-md"
      >
          <h2 className="text-lg lg:text-xl font-bold text-start text-yellow-200 mb-6">
            🌟 What Kinds of Bills Can Win?
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 text-start">
            {[
              {
                title: "🎟️ I Have Ticket",
                items: [
                  "🚆🚌 Train or Bus Ticket",
                  "🎬 Movie Ticket",
                  "⚽🏏 Sports Event Ticket",
                  "🎤 Concert or Event Entry",
                ],
              },
              {
                title: "🧾 I Have Food Bill",
                items: [
                  "🍽️ Street Eats: Samosa, Vada Pav, Pani Puri",
                  "🍛 South Indian Delights: Idly, Dosa, Uttapam",
                  "🥚 Quick Bites: Omelet, Sandwich",
                  "☕🥤 Drinks: Tea, Coffee, Lassi, Milk",
                  "🍱 Meals: Lunch, Dinner – Buffet, Thali or Plate",
                ],
              },
              {
                title: "📲 I Have Recharge Bill",
                items: [
                  "📱 Monthly Mobile Bill",
                  "📺 Monthly Cable Bill",
                  "🎬 Monthly OTT Bill",
                ],
              },
              {
                title: "🛍️ Others",
                items: [
                  "👗💍 Dress & Fashion",
                  "📚✏️ Books & Stationary",
                  "🥦🍎 Vegetables & Fruits",
                  "🥛🧈 Dairy Products",
                  "🍞🧁 Bakery Products",
                  "🚜 Farmer's Utilities",
                  "⛽ Vehicle Fuel",
                  "🔥 LPG",
                ],
              },
            ].map((cat, idx) => (
              <div
                key={idx}
                className="bg-gray-100 p-5 rounded-lg border-l-4 border-teal-500 shadow-sm hover:shadow-lg hover:bg-pink-50 transition-all duration-300"
              >
                <h3 className="font-semibold mb-3 text-teal-700 text-lg">
                  {cat.title}
                </h3>
                <ul className="text-gray-700 text-sm space-y-1">
                  {cat.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
      </section>

      <section id='process' className="py-4 px-4 sm:px-10 bg-gray-600 text-white border border-teal-500 rounded-lg">
        <h2 className="text-lg lg:text-xl text-start font-bold text-yellow-200 mb-4">Here’s How to Jump In</h2>
        <ol className="list-decimal list-inside mx-auto space-y-3 text-white">
          <li>Register on Think5Whys</li>
          <li>Link your Referrer ID</li>
          <li>Provide Bill Number, Date, Amount, Product, Shop Name, Place & PIN</li>
          <li>Check the Leaderboard next day</li>
          <li>Submit UPI to receive money instantly</li>
        </ol>
      </section>

      <section id='rejoice' className="py-4 px-4 sm:px-10 bg-gray-600 border border-teal-500 text-start rounded-lg">
        <h2 className="text-lg lg:text-xl font-bold text-start text-yellow-200 mb-4">Refer & Rejoice</h2>
        <p className="text-white">If someone you referred wins, <strong>you win the SAME amount!</strong> 🤝</p>
        <p className="mt-2 text-white">Even the <strong>shopkeeper</strong> gets ₹1000 if their bill wins!</p>
        <p className="mt-4 text-m text-white">Find your referral code in: Dashboard → My Profile → My Think5Whys Code</p>
      </section>

      <section id='rules' className="py-4 px-4 sm:px-10 bg-gray-600 text-sm text-white text-start rounded-lg border border-teal-500">
        <h2 className="text-lg lg:text-xl text-start font-bold text-yellow-200 mb-4">📜 Rules</h2>
        <ul className="list-disc list-inside mx-auto space-y-2">
          <li>Keep your original bill safe – needed to claim your prize</li>
          <li>Winners chosen by AI – 100% fair and luck-based</li>
          <li>Prize decisions final as per management</li>
          <li>Taxes may apply as per law</li>
          <li>Contest duration may vary based on participation</li>
          <li>Organizer not liable for technical issues</li>
        </ul>
      </section>

      {/* Footer */}
      <footer className="bg-teal-800 text-white py-4 px-4 sm:px-6 md:px-20">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left gap-4 md:gap-0">
          <p className="text-sm">© 2025 Think5Whys Global DeepTech Solutions. All rights reserved.</p>
          <div className="flex flex-wrap justify-center md:justify-start gap-4 md:gap-6 text-sm">
            <Link to="/about-us" className="hover:text-amber-300 transition text-white">About</Link>
            <Link to="/privacy-policy" className="hover:text-amber-300 transition text-white">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-amber-300 transition text-white">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-amber-300 transition text-white">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default KharchoJeetoHome;
